import {
  subCategoryCreateSchema,
  subCategorySchema,
} from "@/schema/console/simple-assessments/SubCategory";
import { z } from "zod";

export const mainCategorySchema = z.object({
  id: z.number(),
  content: z.string(),
  sub_categories: z.array(subCategorySchema),
});

export const mainCategoryCreateSchema = mainCategorySchema
  .omit({
    id: true,
  })
  .extend({
    sub_categories: z.array(subCategoryCreateSchema),
  });
